import { Route } from "react-router-dom";
// import Layout from "./components/layout/Layout";
import Lung from "./pages/Lung";
import Prostate from "./pages/Prostate";
import LungCancer from "./pages/LungCancer";
import SelectCancer from "./pages/SelectCancer";
import ProstateCancer from "./pages/ProstateCancer";
import Main from "./pages/Main";
import Evaluation from "./pages/Evaluation";
import BreastCancer from "./pages/BreastCancer";
import ThyroidCancer from "./pages/ThyroidCancer";

function App() {
  return (
    <div>
      <Route path="/" component={Main} exact />
      <Route path="/lung" component={Lung} />
      <Route path="/lungcancer" component={LungCancer} />
      <Route path="/prostatecancer" component={ProstateCancer} />
      <Route path="/prostate" component={Prostate} />
      <Route path="/breastcancer" component={BreastCancer} />
      <Route path="/thyroidcancer" component={ThyroidCancer} />
      <Route path="/select" component={SelectCancer} />
      <Route path="/evaluation" component={Evaluation} />      
    </div>
  );
}

export default App;
